import { CheckCircle2, Shield, Brain, Zap, Target, Lock, Users, BarChart3, TrendingUp, TrendingDown, Clock, LineChart, Filter, Eye } from 'lucide-react';
import React from 'react';

export const whyCopytrade = [
  {
    icon: <Clock />,
    title: 'Hemat Waktu Kamu',
    description: 'Gak perlu lagi berjam-jam natap chart. Biar profesional yang trading sambil kamu fokus ke kehidupan.'
  },
  {
    icon: <Brain />,
    title: 'Hilangkan Emosi',
    description: 'Takut dan serakah bikin trader rugi jutaan. Otomasi hapus rollercoaster emosional.'
  },
  {
    icon: <TrendingUp />,
    title: 'Belajar dari yang Terbaik',
    description: 'Ikuti strategi terbukti dari trader yang udah master di market.'
  }
];

export const differentiators = [
  {
    icon: <Filter />,
    title: 'Sistem Filter AI',
    description: 'AI kami analisis ribuan strategi secara real-time. Cuma yang profit konsisten dan risiko rendah yang lolos. Tanpa keberuntungan. Tanpa gambling.'
  },
  {
    icon: <Shield />,
    title: 'Performa Terverifikasi Saja',
    description: 'Kami gak biarkan sembarang orang jadi master. Setiap strategi dicek dengan data real dan track record terbukti.'
  },
  {
    icon: <Eye />,
    title: 'Transparansi Penuh',
    description: 'Lihat setiap trade, setiap metrik, setiap detail. Tanpa algoritma tersembunyi. Tanpa black box. Cuma data yang jelas.'
  }
];

export const platformFeatures = [
  {
    icon: <BarChart3 />,
    title: 'Dashboard Performa Live',
    description: 'Pantau profit kamu secara real-time dengan chart yang bersih dan intuitif.'
  },
  {
    icon: <Target />,
    title: 'Pilihan Strategi',
    description: 'Jelajah strategi yang udah di-filter AI. Bandingkan. Pilih. Mulai copy dalam hitungan detik.'
  },
  {
    icon: <Lock />,
    title: 'Aman & Teregulasi',
    description: 'Dana kamu tetap di akun broker kamu sendiri. Teregulasi. Aman. Selalu milik kamu.'
  },
  {
    icon: <Users />,
    title: 'Penarikan Instan',
    description: 'Ambil profit kapan pun kamu mau. Tanpa lock-in. Tanpa biaya tersembunyi. Kontrol penuh.'
  }
];

export const strategies = [
  {
    name: 'Algo FX Master',
    strategyId: 'A10014988',
    provider: 'AI Trading Systems',
    style: 'AI Algorithm',
    winRate: '74.89%',
    drawdown: 'Risk Level 1',
    roi: '+1,694.89%',
    copiers: '10,989',
    profitSharing: '20%',
    return3M: '1,694.89%',
    returnYTD: '4,047,250%',
    maxDailyReturn: '263.92%',
    totalTrades: '4,237',
    mainAsset: 'Multi-Asset',
    status: 'Active'
  },
  {
    name: 'Area101',
    strategyId: 'A10022323',
    provider: 'OmniTrades',
    style: 'Gold Specialist',
    winRate: '63.50%',
    drawdown: 'Risk Level 1',
    roi: '+87,282.18%',
    copiers: '3,390',
    profitSharing: '25%',
    return3M: '87,282.18%',
    returnYTD: '4,764,107%',
    maxDailyReturn: '106.82%',
    totalTrades: '4,383',
    mainAsset: 'XAUUSD (100%)',
    status: 'Active'
  },
  {
    name: 'Trading Assassin 007',
    strategyId: 'A10016051',
    provider: 'Ngoc Hoang Ngan',
    style: 'Intraday Gold',
    winRate: '78.64%',
    drawdown: 'Risk Level 1',
    roi: '+2,395.82%',
    copiers: '4,737',
    profitSharing: '30%',
    return3M: '2,395.82%',
    returnYTD: '1,676,360%',
    maxDailyReturn: '244.36%',
    totalTrades: '871',
    mainAsset: 'XAUUSD (100%)',
    avgHoldingTime: '3.78 hrs',
    tradesPerWeek: '57.87',
    status: 'Active'
  },
  {
    name: 'KING OF USD',
    strategyId: 'A10036767',
    provider: 'Masta Z',
    style: 'Price Action & S&R',
    winRate: '69.54%',
    drawdown: 'Risk Level 1',
    roi: '+23,015.58%',
    copiers: '8',
    profitSharing: '25%',
    return3M: '23,015.58%',
    returnYTD: '23,015.56%',
    maxDailyReturn: '113.83%',
    totalTrades: '1,320',
    mainAsset: 'USD Pairs',
    avgHoldingTime: '0.00 hrs',
    tradesPerWeek: '2,640.00',
    profitableWeeks: '2.00',
    copyAssetUnderManagement: '837.63 USD',
    activeSince: '30/10/2025',
    description: 'Full-time trader with 8 years of experience mastering price action and S&R strategy without using any EA, just pure skill. Aiming for 15%-20% daily growth with strict risk control.',
    status: 'Active'
  },
  {
    name: 'Titan Ai Trades',
    strategyId: 'A10037254',
    provider: 'Titan AI',
    style: 'Intraday Gold',
    winRate: '88.00%',
    drawdown: 'Risk Level 1',
    roi: '+15,847.23%',
    copiers: '500+',
    profitSharing: '30%',
    return3M: '15,847.23%',
    returnYTD: '15,847.23%',
    maxDailyReturn: '80.00%',
    totalTrades: '335',
    mainAsset: 'XAUUSD (51.64%)',
    avgHoldingTime: '4.99 hrs',
    tradesPerWeek: '333.50',
    profitableWeeks: '0.50',
    activeSince: '24/10/2025',
    description: 'AI-powered intraday gold trading strategy with 88% win rate. Focuses on XAUUSD with precision entries and exits. Consistent 80% daily growth targeting with advanced risk management.',
    status: 'Active'
  }
];

// Trustpilot Reviews - Authentic Design
export const trustpilotReviews = [
  {
    id: 1,
    name: 'Mohammad Al-Hashimi',
    location: 'Dubai, UAE',
    country: 'AE',
    rating: 5,
    date: '2 days ago',
    title: 'Outstanding copytrading platform',
    review: "I've tested multiple copytrading services across the region, but Sahara AI stands out with its transparency and consistent results. The AI-filtered strategies give me confidence, and I've seen steady 40%+ returns over 3 months. My capital stays in my account - that's crucial for me. Highly professional service.",
    verified: true
  },
  {
    id: 2,
    name: 'Carlos Reyes',
    location: 'Manila, Philippines',
    country: 'PH',
    rating: 5,
    date: '5 days ago',
    title: 'Life-changing results',
    review: "Started with just $500 as I was skeptical. Four months later, my account is at $2,180 - that's over 300% growth! The Area101 strategy has been incredibly consistent. As someone working full-time, this passive income has been a game-changer for my family. Salamat, Sahara AI!",
    verified: true
  },
  {
    id: 3,
    name: 'Wei Jian Tan',
    location: 'Singapore',
    country: 'SG',
    rating: 5,
    date: '1 week ago',
    title: 'Perfect for busy professionals',
    review: "Working 60+ hours a week in finance doesn't leave time for active trading. Sahara AI's autopilot system has been running for 5 months now with 18% average monthly returns. The dashboard is clean, metrics are transparent, and I've already recommended it to colleagues. Worth every dollar.",
    verified: true
  },
  {
    id: 4,
    name: 'Apinya Srisawat',
    location: 'Bangkok, Thailand',
    country: 'TH',
    rating: 5,
    date: '3 days ago',
    title: 'Genuine passive income',
    review: "I was skeptical about passive income claims, but Sahara AI proved me wrong. Started copying 2 strategies with $1,000 and I'm up 34% in just 6 weeks. The risk management is impressive - even during volatile days, drawdown stayed under 8%. Planning to scale up next month!",
    verified: true
  },
  {
    id: 5,
    name: 'Azman Ibrahim',
    location: 'Kuala Lumpur, Malaysia',
    country: 'MY',
    rating: 5,
    date: '4 days ago',
    title: 'Terbaik! Quit my side job',
    review: "Sebelum ni saya buat Grab part-time, penat sangat. With Sahara AI, I'm earning more than my Grab income tanpa keluar rumah. Started 7 months ago with RM3,000, now at RM7,850. Support team responsive, ada Telegram group. Best financial decision 2024!",
    verified: true
  }
];


export const testimonials = [
  {
    initial: 'B',
    name: 'Budi Santoso',
    location: 'Jakarta',
    text: 'Capek rugi terus nyoba timing market sendiri. Sahara AI kasih balik weekend gua. Akun gua tumbuh sambil gua tidur. Simple as that.'
  },
  {
    initial: 'S',
    name: 'Siti Nurhaliza',
    location: 'Bandung',
    text: 'Total game-changer. Transparan, simpel, profitable. Gua akhirnya paham apa itu "passive income" yang beneran.'
  },
  {
    initial: 'A',
    name: 'Andi Wijaya',
    location: 'Surabaya',
    text: 'Gak ada lagi trading pake emosi. Gak ada lagi tebak-tebakan. Cuma strategi berbasis data yang beneran works. Ini future-nya trading.'
  },
  {
    initial: 'D',
    name: 'Dedi Hermawan',
    location: 'Semarang',
    text: 'Mulai dari Rp 7 juta, sekarang udah Rp 32 juta setelah 4 bulan. Sebagai manager kantoran, gua gak punya waktu belajar trading. Sahara AI bikin semua jadi gampang. Liburan keluarga gua sekarang fully funded!'
  },
  {
    initial: 'R',
    name: 'Rina Permata',
    location: 'Medan',
    text: 'Transparansi dan kontrol penuh atas modal gua yang bikin gua yakin. 3 bulan jalan, return 45% dengan drawdown minimal. Akhirnya nemu platform copytrade yang bisa gua trust buat tabungan gua.'
  },
  {
    initial: 'L',
    name: 'Lina Anggraini',
    location: 'Yogyakarta',
    text: 'Kerja full-time gak ada waktu buat trading. Sahara AI jalan autopilot - profit 32% dalam 6 minggu. Risk management-nya excellent, drawdown gak pernah lewat 8%.'
  }
];